<template>
	<div class="order-manage">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box" style="width: 400px;margin-top:-10px;">
					<label for="start-date">下单时间：</label>
					<span class="order-query-form-input">
						<!-- <el-date-picker  :picker-options="createTimeBegin" v-model="orderForm.createTimeBegin" type="datetime" placeholder="选择日期时间"
							class="setTimePicker" value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker> -->
						<el-date-picker
						    v-model="time"
						    type="datetimerange"
						    range-separator="至"
						    start-placeholder="开始日期"
						    end-placeholder="结束日期"
						    :picker-options="pickerOptions"
							value-format="yyyy-MM-dd HH:mm:ss"
							format="yyyy-MM-dd HH:mm:ss"
						 
							  >
						   </el-date-picker>
					</span>
			
					
				</div>
				<!-- <div class="order-query-form-box" style="width: 180px;">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						<el-date-picker  :picker-options="createTimeEnd" v-model="orderForm.createTimeEnd" type="datetime" placeholder="选择日期时间"
							class="setTimePicker" value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
					</span>
				</div> -->
			
			
				      
			
			
				<div class="order-query-form-box">
					<label for="start-date">订单号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.waybillNo"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">货主名称：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.ownerName"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">车牌号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.driverCarNo"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">司机姓名：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.driverName"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">司机手机：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.driverPhone"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">城市：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.consignCity"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">订单状态：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.waybillState" placeholder="请选择" class="stSetSelect">
							<el-option v-for="item in waybillStateList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 80px;" v-if="isSuperAdmin">
					<label for="start-date">加盟物流:</label>
					<span class="order-query-form-input">
						<el-select style="width:110px;" v-model="orderForm.logisticsCompanyId" placeholder="请选择"
							class="stSetSelect">
							<el-option v-for="item in vehicleList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">货主手机：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.ownerPhone"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">业务员手机：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.salemanPhone"
							name="start-date"></span>
				</div>

				<div class="order-query-form-box" style="width: 80px;" v-if="isSuperAdmin">
					<label for="start-date">加盟订单：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.isFranchise" placeholder="请选择" class="stSetSelect">
							<el-option v-for="item in stWaybillList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 80px;" v-if="isSuperAdmin">
					<label for="start-date">订单类型:</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.createFrom" placeholder="请选择" class="stSetSelect">
							<el-option v-for="item in createFromList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
				
				<div class="order-query-form-box" style="width: 100px;">
					<label for="st-is-order">排除取消订单</label>
					<span class="order-query-form-input"><input type="checkbox" v-model="orderForm.notSee"
							class="st-checkbox" id="st-is-order"></span>
				</div>
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>
		<div class="data-table-box">
			<common-table ref="CommonTableRef" :tableColumns="tableColumns" :data="dataList" :showPage="togglePage"
				:selectType="true" :loading="loading" :showSummary="true" :count-data="dataTotal"
				:pageConfig="pageConfig" :bottomHandleArr="bottomHandleArr" @cellClick="cellClick"
				@selectionChange="selectionChange" @currentChange="currentChange" @sizeChange="sizeChange">
			</common-table>
		</div>
		<st-dialog title="选择司机" :toggleStDialog="toggleStDialog" @closeDialog="toggleStDialog=false"
			@saveDialog="saveDialogForm">
			<div class="st-dialog-content">
				<div class="search-wrapper">
					<span>车牌号：</span></text>
					<el-input class="carno-input" v-model="assignCarNo" size="mini" placeholder="请输入车牌号码"></el-input>
					<el-button type="success" size="mini" @click="serachAssignList()">查询</el-button>
				</div>
				<div class="selDriverBox">
					<el-table :data="driverList" style="width: 100%" height="200" class="st-table-center">
						<el-table-column width="80" label="操作">
							<template slot-scope="scope">
								<el-radio :label="scope.row.id"  v-model="selDriverId"><i> </i>
								</el-radio>
							</template>
						</el-table-column>
						<el-table-column prop="carNo" label="车牌号">
						</el-table-column>
						<el-table-column prop="name" label="姓名">
						</el-table-column>
						<el-table-column prop="phone" label="电话">
						</el-table-column>
					</el-table>
				</div>
			</div>
		</st-dialog>
	</div>
</template>
<script>
	import stDialog from '../../components/StDialog'
	export default {
		name: 'OrderManage',
		props: [],
		data() {
			return {
				dataList: [], //订单列表
				  time:[],
				   //不能选择当前日期之后的时间
				      pickerOptions: {
				          disabledDate(time) {
				            return time.getTime() > Date.now();
				          }
				        },
				dataTotal: {},
				vehicleList:[{name:null,id:null}],//加盟物流公司列表
				isSuperAdmin: false,
				loading: false,
				togglePage: false,
				pageConfig: {
					total: 0,
					pageSize: 100,
					currentPage: 1,
				},
				bottomHandleArr: [{
						label: '订单位置图',
						type: 'success',
						handler: () => this.toSpellMap()
					},
					{
						label: '拼单规则',
						type: 'success',
						handler: () => this.toSpellList()
					},
					// {
					// 	label: '删除订单',
					// 	handler: () => this.delList()
					// },
					{
						label: '导出',
						type: 'success',
						handler: () => this.exportTable()
					},
					{
						label: '指派司机',
						type: 'success',
						handler: () => this.showDriverDialog()
					},
				],
				tableColumns: [{
						type: 'selection',
						fixed: 'left',
					},
					{
						index: true,
						fixed: 'left',
						align: 'center',
						title: '序号',
					},
					{
						key: '',
						title: '操作',
						align: 'center',
						operate: true,
						width: '200',
						setBtns: (row, index) => {
							return [{
								label: '取消',
								style: row.state != 3 ? "color:#FF5B3E;" :
									"color:#606266;",
								disabled: row.state != 3 ? false : true,
								handler: (row, index) => this.cancelOrder(row)
							}, {
								label: '确认到货',
								style: row.state === 2 ? "color:#67C23A;" : "color:#606266;",
								disabled: row.state === 2 ? false : true,
								handler: (row, index) => this.confirmArrive(row)
							}, ]
						}
					},
					{
						key: 'createTimeFormatted',
						align: 'center',
						title: '下单时间'
					},
					{
						key: 'waybillNo',
						width: '110',
						className: 'optionWaybillNo',
						align: 'center',
						title: '订单号'
					},
					{
						key: 'stateDesc',
						width: '80',
						align: 'center',
						title: '订单状态'
					},
					{
						key: 'consignShortAddress',
						width: '250px',
						title: '始发地'
					},
					{
						key: 'receiveShortAddress',
						title: '目的地'
					},
					{
						key: 'ownerName',
						align: 'center',
						title: '货主名称'
					},
					{
						key: 'ownerPhone',
						width: '100',
						align: 'center',
						title: '货主手机'
					},
					{
						title: '发货人',
						align: 'center',
						width: '80',
						exportProp: 'contactSubject',
						render: function(h, {
							row
						}) {
							return h('span', row.consign.contactSubject)
						}
					},
					{
						key: 'weight',
						width: '100',
						align: 'center',
						title: '重量'
					},
					{
						key: 'volume',
						width: '100',
						align: 'center',
						title: '方数'
					},
					{
						title: '省',
						exportProp: 'provinceName',
						width: '80',
						align: 'center',
						render: function(h, {
							row
						}) {
							return h('span', row.consign.provinceName)
						}
					},
					{
						title: '市',
						align: 'center',
						exportProp: 'cityName',
						width: '80',
						render: function(h, {
							row
						}) {
							return h('span', row.consign.cityName)
						}
					},
					{
						title: '区',
						align: 'center',
						exportProp: 'areaName',
						width: '80',
						render: function(h, {
							row
						}) {
							return h('span', row.consign.areaName)
						}
					},
					{
						key: 'ownerExpressFee',
						width: '80',
						align: 'center',
						title: '订单金额'
					},
					{
						key: 'driverExpressFee',
						width: '90',
						align: 'center',
						title: '付司机运费'
					},
					{
						key: 'profit',
						width: '80',
						align: 'center',
						title: '利润'
					},
					{
						key: 'driverName',
						align: 'center',
						title: '司机姓名'
					},
					{
						key: 'driverPhone',
						align: 'center',
						title: '司机手机'
					},
					{
						key: 'driverCarNo',
						align: 'center',
						title: '司机车牌号'
					},
					{
						key: 'pickupTimeFormatted',
						align: 'center',
						title: '预约提货时间'
					},
					{
						key: 'salemanPhone',
						align: 'center',
						title: '业务员手机号',
						render: function(h, {
							row
						}) {
							return h('span', row.salemanVO.phone)
						}
					},
					{
						key: 'salemanName',
						align: 'center',
						title: '业务员名称',
						render: function(h, {
							row
						}) {
							return h('span', row.salemanVO.name)
						}
					},


				],
				assignCarNo: '',
				orderForm: {
					createTimeBegin: null, // 下单起始时间  string  格式：yyyy-MM-dd HH:mm:ss
					createTimeEnd: null, // 下单结束时间  string  格式：yyyy-MM-dd HH:mm:ss
					waybillNo: null, // 订单号 number  
					ownerName: null, // 货主名称  string  
					driverCarNo: null, // 车牌号 string  
					driverName: null, //  司机姓名  string  
					driverPhone: null, // 司机手机  string  
					ownerPhone: null, //  货主手机  string  
					isFranchise: null, // 是否加盟 0 为加盟 1已加盟
					createFrom: null,
					waybillState: "", // 运单状态 number 0 = 未接单、 1 = 已接单、 2 = 运输中、 3 = 已完成、 99 = 已取消
					consignCity: '',
					notSee: true,
					salemanPhone: null,
				},
				selDriverId: null, //选中的司机
				selectedList: [], // 选中的列表
				driverList: [], // 司机列表
				toggleStDialog: false, // 弹窗
				waybillStateList: [{
					value: '',
					label: '全部'
				}, {
					value: '0',
					label: '未接单'
				}, {
					value: '-1',
					label: '未支付'
				}, {
					value: '1',
					label: '已接单'
				}, {
					value: '2',
					label: '运输中'
				}, {
					value: '3',
					label: '已完成'
				}, {
					value: '99',
					label: '已取消'
				}],
				stWaybillList: [{
						value: null,
						label: '全部',
					},
					{
						value: 0,
						label: '未加盟',
					},
					{
						value: 1,
						label: '已加盟',
					},
				],
				createFromList: [{
						value: null,
						label: '全部',
					},
					{
						value: 'OWNER',
						label: '普通单',
					},
					{
						value: 'ADMIN',
						label: '拼单',
					}
				],
				serarchState: ''
			}
		},
		components: {
			stDialog
		},
	created() {
	    if (process.client) {
	      const that = this;
	      that.getTimeFn();
	    }
	  },

		methods: {
			/**
			 * 设置默认时间
			 */
			getTimeFn() {
			  const that = this;
			  const end = new Date();
			  const start = new Date();
			  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
			  that.deviceFormData.time[0] = that.formatDate(start);
			  that.deviceFormData.time[1] = that.formatDate(end);
			},
			/**
			 * 格式化时间
			 */
			formatDate(date) {
			  var myyear = date.getFullYear();
			  var mymonth = date.getMonth() + 1;
			  var myweekday = date.getDate();
			
			  if (mymonth < 10) {
			    mymonth = "0" + mymonth;
			  }
			  if (myweekday < 10) {
			    myweekday = "0" + myweekday;
			  }
			  return myyear + "-" + mymonth + "-" + myweekday;
			},
			sizeChange(size) {
				this.pageConfig.currentPage = 1
				this.pageConfig.pageSize = size
				this.searchList()
			},
		
			currentChange(currentPage) {
				this.pageConfig.currentPage = currentPage
				this.searchList()
			},
			//   拼单
			toSpellList() {
				const stRulesFun = (item, index) => {
					if (item.state == 0 || item.state == -1) {
						return false
					}
					return true
				}

				if (this.ifHaveOtherOrders(this.selectedList, stRulesFun)) {
					return this.$message('请选择未支付或未接单的订单');
				}

				this.$store.dispatch('common/addTab', {
					title: '拼单规则',
					path: 'business/spellList',
					name: 'SpellList',
					params: {
						stList: this.selectedList
					}
				})
			},

			ifHaveOtherOrders(dataList = [], rulesFun) {
				return dataList.some(rulesFun)
			},

			selectionChange(val) {
				this.selectedList = val;
			},
			cellClick(row, column) {
				if (column.property !== "waybillNo") return;
				this.$store.dispatch('common/addTab', {
					title: '订单详情',
					path: 'business/orderDetail',
					name: 'OrderDetail',
					params: {
						waybillNo: row.waybillNo
					}
				})
			},
			toSpellMap() {
				let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
				if (userInfo.genre !== 'FRANCHISE') {
					return this.$toast.stMessage('暂无权限，只有加盟公司才能操作此功能', false)
				}
				let orderParams = JSON.parse(JSON.stringify(this.orderForm))
				orderParams.createTimeBegin = orderParams.createTimeBegin ? new Date(orderParams.createTimeBegin)
				.getTime() : ''
				orderParams.createTimeEnd = orderParams.createTimeEnd ? new Date(orderParams.createTimeEnd).getTime() : ''

				this.$store.dispatch('common/addTab', {
					title: '订单位置图',
					path: 'business/orderMap',
					name: 'OrderMap',
					params: {
						orderParams
					}
				})
			},
			searchList(flag) {
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				if (flag) pages.current = 1;
				this.loading = true
				let orderForm = this.orderForm;
				Object.assign(orderForm, pages)
				this.getData(orderForm)
			},

			getData(data) {
				data.createTimeBegin = this.time[0]
				data.createTimeEnd = this.time[1]
				const sendData = {
					...data
				}
				
				sendData.createTimeBegin = data.createTimeBegin ? new Date(data.createTimeBegin).getTime() : ''
				sendData.createTimeEnd = data.createTimeEnd ? new Date(data.createTimeEnd).getTime() : ''
				this.$server.business.getWaybillCount(sendData, (res) => {
					console.log('合计结果', res.data)
					this.dataTotal = res.data
					console.log(this.dataTotal)
				})
				this.$server.business.waybillPage(sendData, (res) => {
					console.log(this.time)
					this.loading = false
					this.dataList = res.data.records;
					this.pageConfig.total = res.data.total;
					this.pageConfig.currentPage = res.data.current;
					this.serarchState = this.orderForm.waybillState
					if (res.data.total > 0) {
						this.togglePage = true;
					}
				})
			},
			cancelOrder(row) {
				let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
				if (userInfo.genre !== 'SYSTEM') {
					return this.$toast.stMessage('暂无权限，只有系统用户才能操作此功能', false)
				}
				this.$server.business.cancelWaybill(row.waybillNo, (res) => {
					this.$toast.stMessage('取消成功', true)
					this.searchList()
				})
			},
			confirmArrive(row) {
				let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
				if (userInfo.genre !== 'SYSTEM') {
					return this.$toast.stMessage('暂无权限，只有系统用户才能操作此功能', false)
				}
				this.$server.business.completeWaybill(row.waybillNo, (res) => {
					this.$toast.stMessage('操作成功', true)
					this.searchList()
				})
			},
			// 删除订单
			delList() {
				let that = this;
				if (this.selectedList.length < 1) {
					that.$toast.stMessage('请选择订单', true)
					return;
				}
				let selectedLength = this.selectedList.length - 1;
				let setTime = setInterval(() => {
					let waybillNo = that.selectedList[selectedLength].waybillNo;
					this.$server.business.deleteWaybill(waybillNo, (res) => {
						if (res.code != 0) {
							that.$toast.stMessage(res.message, false)
							return false;
						}
					})
					selectedLength--;
					if (selectedLength < 0) {
						that.$toast.stMessage('删除成功', true)
						clearInterval(setTime)
						that.searchList();
					}
				}, 100)
			},
			cellClass(row) {
				// if (row.columnIndex === 0) {
				// 	return 'disabledCheck'
				// }
			},
			// 导出
			exportTable() {
				if (this.dataList.length < 1) {
					this.$toast.stMessage('暂无订单', true)
					return;
				}
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage
				const sendData = {
					...this.orderForm,
					exportColumnFiledNames: this.tableColumns.map((item) => {
						return item.exportProp || item.key
					}).filter(item => {
						return item && item.trim()
					})
				}
				sendData.createTimeBegin = sendData.createTimeBegin ? new Date(sendData.createTimeBegin).getTime() : ''
				sendData.createTimeEnd = sendData.createTimeEnd ? new Date(sendData.createTimeEnd).getTime() : ''
				Object.assign(sendData, pages)
				this.$server.common.exportTable('/business/waybill-page-export', sendData, (res) => {
					console.log('导出成功')
				})
			},
			serachAssignList() {
				let data = {};
				data.userType = 2; //司机
				data.current = 1;
				data.size = 1000;
				data.isAudit = 1
				data.carNo = this.assignCarNo
				this.$server.business.userPage(data, (res) => {
					if (res.code == 0) {
						// 处理只显示未接单和已认证的司机
						this.driverList = res.data;
					} else {
						this.$toast.stMessage(res.message, false)
					}
				})
			},
			//获取物流公司名称
			 getCompanyName(){
			        this.$server.business.getCompany(res=>{
			          console.log(res)
			          // this.vehicleForm.model=res.data[0]
			          this.vehicleList=  this.vehicleList.concat(res.data)
					  console.log( this.vehicleList)
			        })
			      },
			// 获取司机列表
			showDriverDialog() {
				let that = this;
				if (this.selectedList.length < 1) {
					that.$toast.stMessage('请选择订单', true)
					return;
				}
				this.toggleStDialog = true;
				let data = {};
				this.driverList = []
				this.assignCarNo = ''
				data.userType = 2; //司机
				data.current = 1;
				data.size = 1000;
				data.isAudit = 1
				this.$server.business.userPage(data, (res) => {
					if (res.code == 0) {
						// 处理只显示未接单和已认证的司机
						this.driverList = res.data;
					} else {
						that.$toast.stMessage(res.message, false)
					}
				})
			},

			// 指派司机
			saveDialogForm() {
				let that = this;
				if (this.selectedList.length < 1) {
					that.$toast.stMessage('请选择订单', true)
					return;
				}
				let data = {};
				data.driverId = this.selDriverId;
				let selectedLength = this.selectedList.length - 1;
				let setTime = setInterval(() => {
					data.waybillNo = that.selectedList[selectedLength].waybillNo;
					this.$server.business.designateWaybill(data, (res) => {
						if (res.code != 0) {
							that.$toast.stMessage(res.message, false)
						} else {
							that.$toast.stMessage(`订单${data.waybillNo}指派成功`, true)
						}
					})
					selectedLength--;
					if (selectedLength < 0) {
						clearInterval(setTime)
						that.searchList();
					}
				}, 100)
				this.toggleStDialog = false;
			},
			// 一建下单
			oneCreateOrder() {
				this.$toast.stMessage('暂无此功能', true)
			},
		},
		mounted() {
			// 查看近一周时间
		  const end = new Date();
		  const start = new Date();
		  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
		  // picker.$emit('pick', [start, end]);
		  this.time = [start,end]
		  console.log( this.time )
			this.getCompanyName()
			// 判断是否是超级管理员
			this.$server.role.getRoleOfUser(this.$store.getters.id, res => {
				if (res.data.length > 0) {
					this.isSuperAdmin = true
				}
			})
		}
	}
</script>
<style scoped>
	.order-manage {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.query-setting-box-left {
		flex: 1;
	}

	.order-query-form-box {
		float: left;
		width: 140px;
		height: auto;
		margin: 0 24px 18px 0;
	}

	.order-query-form-box-right {
		width: 80px;
	}

	.order-query-form-box label {
		display: block;
		width: 100%;
		height: 22px;
		line-height: 22px;
		color: #383838;
	}

	.order-query-form-box input {
		display: block;
		width: 99%;
		height: 28px;
		line-height: 28px;
		border: 1px solid #DCDCDC;
		border-radius: 3px;
		text-indent: 8px;
	}

	.order-query-form-submit {
		display: block;
		width: 80px;
		height: 28px;
		line-height: 28px;
		text-align: center;
		color: #FFF;
		background: #FF5B3E;
		border: 1px solid #FF5B3E;
		border-radius: 3px;
		margin: 0 auto;
	}

	.data-table {
		margin-bottom: 8px;
	}

	.st-page-switch {
		float: left;
		width: 95px;
		height: 30px;
		background: #FF5B3E;
		border-radius: 2px;
		position: relative;
		margin-right: 28px;
	}

	.st-page-prev {
		position: absolute;
		left: 4px;
		top: 0;
		width: 16px;
		height: 30px;
		background: url('../../assets/images/icon_prev.png') center no-repeat;
		background-size: 8px 12px;
		cursor: pointer;
	}

	.st-page-next {
		position: absolute;
		right: 4px;
		top: 0;
		width: 16px;
		height: 30px;
		background: url('../../assets/images/icon_next.png') center no-repeat;
		background-size: 8px 12px;
		cursor: pointer;
	}

	.st-page-current {
		position: absolute;
		left: 50%;
		top: 3px;
		margin-left: -18px;
		width: 35px;
		height: 24px;
		background: #fff;
	}

	.st-page-current input {
		width: 35px;
		height: 24px;
		border: none;
		text-align: center;
		outline: none;
	}

	.st-page-every-total {
		float: left;
		background: #FF5B3E;
		border-radius: 2px;
		font-size: 14px;
		color: #fff;
		position: relative;
	}

	.st-page-every {
		position: absolute;
		left: 0;
		top: 0;
		line-height: 30px;
		width: 30px;
		text-align: center;
		z-index: 1;
	}

	.stStgz {
		background-color: #4D60C7;
	}

	/* .st-page-pagers{
	float: left;
	width: 83px;
	background: #FF5B3E;
	border-radius: 2px;
	font-size: 14px;
	color: #fff;
	position: relative;
	margin-right: 6px;
	overflow: hidden;

}
.st-page-pagers .el-input__suffix{
	top: 0;
	right: 0;
}
.st-page-pagers .el-input__icon{
	line-height: 30px;
}
.st-page-total{
	float: left;
	color:#6B6F74;
	line-height:30px;
	font-size: 14px;
} */
	.st-order-bottom {
		height: 30px;
		font-size: 14px;
	}

	.st-order-btns {
		display: flex;
		justify-content: space-around;
	}

	.st-order-btns span {
		width: 80px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		color: #fff;
		border-radius: 2px;
		cursor: pointer;
		margin-left: 8px;
	}

	.search-wrapper {
		display: flex;
		height: 60px;
		align-items: center;
		padding-left: 30px;
	}

	.carno-input {
		width: 200px;
		margin: 0 20px;
	}

	input.st-checkbox {
		width: 22px;
		height: 22px;
		background-color: #fff;
		-webkit-appearance: none;
		border: 1px solid #949494;
		outline: none;
		cursor: pointer;
		margin-top: 3px;
	}

	input.st-checkbox[type=checkbox]:checked {
		background: url('../../assets/images/st_checkbox.png') center no-repeat;
		background-size: 100% 100%;
		border: none;
	}

	.selDriverBox {
		position: relative;
		width: 580px;
	}
</style>
